import styled from "@emotion/styled";
import { Divider, Link, Stack, Typography } from "@mui/material";
import React from "react";
import themes from "../../../themes";

interface FooterProps {}

export const Footer = ({ ...props }: FooterProps) => {
  return (
    <>
      <StackWrapper>
        <LinkWrapper>
          <StyledLink
            href="https://cdn.otaku-coin.com/app/en/agreement/index.html"
            color="inherit"
            underline="hover"
            rel={"noopener noreferrer"}
            target={"_blank"}
          >
            Terms of Use
          </StyledLink>
          <span>|</span>
          <StyledLink
            href="https://cdn.otaku-coin.com/app/en/privacy/index.html"
            color="inherit"
            underline="hover"
            rel={"noopener noreferrer"}
            target={"_blank"}
          >
            Privacy Policy
          </StyledLink>
          <span>|</span>
          <StyledLink
            href="https://twitter.com/OtakuCoinEn"
            color="inherit"
            underline="hover"
            rel={"noopener noreferrer"}
            target={"_blank"}
          >
            Twitter
          </StyledLink>
        </LinkWrapper>
      </StackWrapper>
      <div>
        <Copyright align="center">
          © Otaku Coin Association / Copyright © TART K.K.
          {new Date().getFullYear()}.
        </Copyright>
      </div>
    </>
  );
};

const StyledLink = styled(Link)`
  font-size: 14px;
`;

const LinkWrapper = styled.div`
  & > span {
    padding: 0 8px;
  }
  @media screen and (max-width: 420px) {
    display: block;
    & > span {
      display: none;
    }
    & > a {
      display: block;
      padding: 16px 24px;
      border-bottom: 1px solid #000;
    }
  }
`;

export const StyledDivider = styled(Divider)`
  border-color: #fff;
`;

const StackWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: ${themes.spacing(1)};
  margin-bottom: ${themes.spacing(2)};
  background-color: #ffffff5c;
  @media screen and (max-width: 420px) {
    display: block;
    padding: 0;
  }
`;

const Copyright = styled(Typography)`
  font-size: 10px;
  font-weight: bold;
  padding-bottom: ${themes.spacing(2)};
`;
